<mat-toolbar class="mat-primary">
  <span class="fill-remaining-space">Persönliche Daten</span>
  <mat-icon class="cursor-mat-element" (click)="close()">close</mat-icon>
</mat-toolbar>

<mat-dialog-content>
  <div class="form-group">
    <h2 for="tenants">Kontaktdaten</h2>

    <app-edit-contact-data
      [data]="model.contactData"
      [disableFieldsForInstaller]="isInstallerUser"
      [showAddress]="false"></app-edit-contact-data>
  </div>

  <mat-form-field appearance="outline" fxFlexAlign="stretch" *ngIf="!isInstallerUser">
    <mat-label>Externe-Id:</mat-label>
    <input matInput type="text" [(ngModel)]="model.externalId" />
  </mat-form-field>

  <div>
    <h2>Zugewiesene Rollen</h2>
    <ul>
      <li style="list-style: none" *ngFor="let role of model.roles">
        {{ role.id }} - {{ role.description || role.name }}
        <hr />
      </li>
    </ul>
    <!--Todo: Link für Rollen-Beschreibungen einfügen-->
  </div>

  <!-- hier kommen Debug features rein -->
  <div>
    <h3>Debug Funktionen</h3>
    <p class="debug-description">
      Beim Zurücksetzen der Einstellungen werden alle gespeicherten Benutzereinstellungen und Konfigurationen
      in der Anwendung gelöscht. Dies kann bei Problemen mit der Benutzeroberfläche helfen.
    </p>
    <button mat-stroked-button color="warn" (click)="resetBackofficeSettings()">
      Einstellungen zurücksetzen
    </button>
  </div>
  <div class="button-container">
    <button mat-stroked-button color="primary" (click)="this.dataShareService.resetConfiguration()">
      Zurücksetzen
    </button>
    <button mat-raised-button (click)="confirm(model.contactData)" color="primary" type="submit">
      Speichern
    </button>
  </div>
</mat-dialog-content>
